query getSportsbookSeo {
  sportsbookSeo {
    metaTitle
    metaDescription
    seoText
    h1
    ogTitle
    ogDescription
  }
}
